var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    className: "icon delete-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "icon__bg delete-icon__bg",
    cx: 16,
    cy: 16,
    r: 15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon__border delete-icon__border",
    d: "M16,32c-4.1,0-8.2-1.56-11.32-4.68c-6.24-6.24-6.24-16.39,0-22.63C7.7,1.66,11.72,0,16,0s8.3,1.66,11.32,4.69         c6.24,6.24,6.24,16.39,0,22.63l0,0C24.2,30.44,20.1,32,16,32z M16,1.69c-3.82,0-7.42,1.49-10.12,4.19c-5.58,5.58-5.58,14.66,0,20.24         c5.58,5.58,14.66,5.58,20.24,0c5.58-5.58,5.58-14.66,0-20.24C23.42,3.18,19.82,1.69,16,1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon__mark delete-icon__mark",
    d: "M23.42,17.7H8.58c-0.94,0-1.7-0.76-1.7-1.7c0-0.94,0.76-1.7,1.7-1.7h14.83c0.94,0,1.7,0.76,1.7,1.7         C25.11,16.94,24.35,17.7,23.42,17.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.68e17b0f41e8d404f28f3a3668a0da33.svg";
export { ForwardRef as ReactComponent };